import $ from "jquery";
// Import von Lodash
import { throttle } from 'lodash';

$(function() {


    $(".hero-slider").slick({
		autoplay: false,
		autoplaySpeed: 5000,
		fade: true,
		dots: true,
	});
    $(".leistungen-slider").slick({
		slidesToShow: 3,
		autoplay: false,
		infinite: true,
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 2,
			  }
			},
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 1,
			  }
			},
		]
	});
    $(".referenzen-slider").slick({
		slidesToShow: 3,
		autoplay: false,
		infinite: true,
		variableWidth: true,
		centerMode: true,
		responsive: [
			{
			  breakpoint: 640,
			  settings: {
				slidesToShow: 1,
				variableWidth: false,
				centerMode: false,
			  }
			},
		]
	});
    $(".team-slider").slick({
		slidesToShow: 1,
		autoplay: false,
		mobileFirst: true,
		infinite: true,
		responsive: [
			{
			  breakpoint: 576,
			  settings: {
				slidesToShow: 2,
			  }
			},
			{
			  breakpoint: 1200,
			  settings: {
				slidesToShow: 3,
			  }
			},
		]
	});
    $(".referenzen-page-slider").slick({
		slidesToShow: 1,
		autoplay: false,
		mobileFirst: true,
		infinite: true,
		responsive: [
			{
			  breakpoint: 576,
			  settings: {
				slidesToShow: 2,
			  }
			},
			{
			  breakpoint: 1200,
			  settings: {
				slidesToShow: 3,
			  }
			},
		]
	});

	const adminBar = document.getElementById("wpadminbar");

	//header visibility
	// Selektiere den Header
	const header = document.querySelector('#primary-header');

	// Sticky header offset wenn die Adminbar sichtbar ist.
	if(adminBar && document.documentElement.clientWidth >= 600) {
		header.style = `top: ${adminBar.offsetHeight}px`
	}

	// Verstecke den Header beim Runter-Scrollen und zeige ihn beim Hoch-Scrollen
	let lastScrollPosition = 0;
	window.addEventListener('scroll', throttle(function() {
	const currentScrollPosition = window.scrollY;
	if (currentScrollPosition > lastScrollPosition) {
		// Runter-Scrollen
		if (currentScrollPosition > 200) {
		header.classList.add('hidden');
		}
	} else {
		// Hoch-Scrollen
		header.classList.remove('hidden');
	}
	lastScrollPosition = currentScrollPosition;
	}, 50));

	//scroll down btn
	const scrollDownBtns = document.querySelectorAll(".btn-scroll-down")

	scrollDownBtns.forEach(btn => {
		btn.addEventListener("click", scrollDownABit)
	});

	function scrollDownABit(event) {
		const nextSectionOffset = event.target.parentElement.parentElement.parentElement.parentElement.nextElementSibling.offsetTop
		document.documentElement.scrollTop = nextSectionOffset
	}
	
});